import { render, staticRenderFns } from "./SalesOverview.vue?vue&type=template&id=0cfe4fb1&scoped=true"
import script from "./SalesOverview.vue?vue&type=script&lang=js"
export * from "./SalesOverview.vue?vue&type=script&lang=js"
import style0 from "./SalesOverview.vue?vue&type=style&index=0&id=0cfe4fb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfe4fb1",
  null
  
)

export default component.exports